/**
 * Resolves the array of display images for a car. For new-model showroom
 * cars (Autodis OMODA/JAECOO, issue #884) the wide hero shot from
 * `landscapeImage` is prepended so it becomes the primary thumbnail
 * everywhere — inventory list, catalog cards, search dropdowns — matching
 * what the landing page renders. Used-VIN cars fall through to `images[]`
 * unchanged (Andys/ShiftGears flow).
 *
 * Если `landscapeImage` уже первый элемент `images[]`, дублирования не
 * будет — фильтр по равенству убирает повторение.
 *
 * @param {{ isNewModel?: boolean, landscapeImage?: string|null, images?: string[] }} car
 * @returns {string[]} array of image URLs (may be empty)
 */
export const getDisplayImages = (car) => {
  if (!car) return [];
  const baseImages = Array.isArray(car.images) ? car.images : [];
  if (car.isNewModel && typeof car.landscapeImage === 'string' && car.landscapeImage) {
    return [
      car.landscapeImage,
      ...baseImages.filter((u) => u !== car.landscapeImage),
    ];
  }
  return baseImages;
};

/**
 * Convenience helper — returns the first display image (or null if none).
 * Для new-model cars приоритет у `landscapeImage`, для used-VIN — `images[0]`.
 * Используется в местах где нужен один thumbnail (search dropdowns,
 * inventory thumbnail), без логики carousel.
 *
 * NOTE: эта же логика отзеркалена в b2b-ui:
 * `apps/b2b-ui/src/app/features/inventory/catalog-tab/catalog-tab.component.ts`
 * → `getCarThumbnail()`. Если меняешь поведение здесь — обнови и там
 * (Angular/TS не может импортить из b2b-demo напрямую, см. discussion #22477
 * на MR !787; полноценный shared lib — отдельный follow-up).
 *
 * @param {{ isNewModel?: boolean, landscapeImage?: string|null, images?: string[] }} car
 * @returns {string|null}
 */
export const getDisplayImage = (car) => {
  const images = getDisplayImages(car);
  return images.length > 0 ? images[0] : null;
};
